export default __webpack_public_path__ + "bea5eccc7328f971071392e74bb411e5.png";